// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1b1822b1","239":"dcfb2cf7","455":"82f18ed3","488":"e1a60c01"}[chunkId] + ".chunk.js";
};